import type { Card } from '../game/types';

export const STARTER_DECK_IDS = Object.freeze([
  '69ad1cd16e275c00a7772d24',
  '69ad1ba56e275c00a7772d1c',
  '69a63e4c15bb106e96218a89',
  '699b8d5b93484dab4a0846f2',
  '6998d1b50bebb02c4299bfba',
  '6998ce370bebb02c4299bf96',
  '6998cb530bebb02c4299bf80',
  '6998cadc0bebb02c4299bf7d',
  '699fc3a6fc5a38a7edef229b',
  '6998d09c0bebb02c4299bfb2',
  '6998d2030bebb02c4299bfbe',
  '6998c9810bebb02c4299bf77',
  '69ad28696e275c00a7772d3a',
  '6998c83c0bebb02c4299bf73',
  '699fbb04ef389e8b8e30dbf5',
  '699bdbb258341bc8aaddc4dc',
] as const);

type CardLike = Pick<Card, 'id'> | { id?: string | null | undefined };

export function sanitizeDeckIdsAgainstLibrary(
  library: CardLike[] | undefined,
  ids: readonly string[] | undefined
): string[] {
  const knownIds = new Set(
    (Array.isArray(library) ? library : [])
      .map((card) => String(card?.id ?? '').trim())
      .filter(Boolean)
  );

  const sanitized: string[] = [];
  const seen = new Set<string>();

  for (const rawId of Array.isArray(ids) ? ids : []) {
    const id = String(rawId ?? '').trim();
    if (!id || seen.has(id) || !knownIds.has(id)) continue;
    seen.add(id);
    sanitized.push(id);
  }

  return sanitized;
}

export function getStarterDeckIdsForLibrary(library: CardLike[] | undefined): string[] {
  return sanitizeDeckIdsAgainstLibrary(library, STARTER_DECK_IDS);
}

export function resolveInitialDeckIds(
  library: CardLike[] | undefined,
  requestedIds: readonly string[] | undefined
): string[] {
  const sanitizedRequested = sanitizeDeckIdsAgainstLibrary(library, requestedIds);
  if (sanitizedRequested.length > 0) return sanitizedRequested;
  return getStarterDeckIdsForLibrary(library);
}
